module.exports = __webpack_public_path__ + "img/news3.e23f2715.png";